export default __webpack_public_path__ + "static/media/keep-me-company.0b619b50.svg";